// src/component/Footer.jsx
import { FaTelegramPlane, FaWhatsapp, FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";

const storePhones = [
  {
    label: "Ивановская, 6/4",
    tel: "tel:+79146876464",
    text: "+7 (914) 687-64-64",
  },
  {
    label: "Проспект 100-летия Владивостока, 43",
    tel: "tel:+79940076464",
    text: "+7 (994) 007-64-64",
  },
  { label: "ТЦ «Море»", tel: "tel:+79024886464", text: "+7 (902) 488-64-64" },
];

const Footer = () => (
  <footer className="bg-[#181818] text-gray-100 pt-12 pb-6 px-4">
    {/* 4 колонки на md+, увеличили расстояние между ними */}
    <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-8 md:gap-12 xl:gap-16">
      {/* Информация */}
      <div>
        <h5 className="font-bold mb-4">Информация</h5>
        <ul className="space-y-2 text-sm">
          <li>
            <Link
              to="/warranty"
              className=" hover:text-orange-600 hover:underline"
            >
              Гарантийное обслуживание
            </Link>
          </li>
          <li>
            <a
              href="https://2gis.ru/search/mi64"
              target="_blank"
              rel="noopener noreferrer"
              className=" hover:text-orange-600 hover:underline"
            >
              Наши магазины в 2ГИС
            </a>
          </li>
          <li>
            <a
              href="https://mi64.eight-percent.com/Soglashenie"
              target="_blank"
              rel="noopener noreferrer"
              className=" hover:text-orange-600 hover:underline"
            >
              Соглашение на обработку персональных данных
            </a>
          </li>
        </ul>
      </div>

      {/* О нас */}
      <div>
        <h5 className="font-bold mb-4">О нас</h5>
        <ul className="space-y-2 text-sm">
          <li>
            <a href="/about" className=" hover:text-orange-600 hover:underline">О компании Mi64</a>
          </li>
          <li>
            <a href="/price" className=" hover:text-orange-600 hover:underline">Каталог товаров</a>
          </li>
        </ul>
      </div>

      {/* Телефоны */}
      <div>
        <h5 className="font-bold mb-4">Телефоны</h5>
        <ul className="space-y-2 text-sm">
          {storePhones.map((s) => (
            <li
              key={s.label}
              className="grid grid-cols-[minmax(0,1fr)_auto] items-baseline gap-x-3"
            >
              <span className="text-gray-300 leading-tight break-words">
                {s.label}
              </span>
              <a
                href={s.tel}
                className="text-gray-100 hover:text-orange-600 hover:underline whitespace-nowrap"
              >
                {s.text}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* Мы в соцсетях */}
      <div>
        <h5 className="font-bold mb-4">Мы в соцсетях</h5>
        <div className="flex gap-3">
          <a
            href="https://t.me/Mi64Store"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative w-9 h-9 bg-[#232323] rounded-full flex items-center justify-center hover:bg-[#333] transition"
          >
            <FaTelegramPlane className="text-white w-5 h-5" />
            <span className="absolute bottom-12 left-1/2 -translate-x-1/2 px-2 py-1 bg-black text-xs text-white rounded opacity-0 group-hover:opacity-100 transition">
              Telegram
            </span>
          </a>

          <a
            href="https://wa.me/79146876464"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative w-9 h-9 bg-[#232323] rounded-full flex items-center justify-center hover:bg-[#333] transition"
          >
            <FaWhatsapp className="text-white w-5 h-5" />
            <span className="absolute bottom-12 left-1/2 -translate-x-1/2 px-2 py-1 bg-black text-xs text-white rounded opacity-0 group-hover:opacity-100 transition">
              WhatsApp
            </span>
          </a>

          <a
            href="https://www.instagram.com/mi64store?igsh=MXJobmdubGxiOWhiMg=="
            target="_blank"
            rel="noopener noreferrer"
            className="group relative w-9 h-9 bg-[#232323] rounded-full flex items-center justify-center hover:bg-[#333] transition"
          >
            <FaInstagram className="text-white w-5 h-5" />
            <span className="absolute bottom-12 left-1/2 -translate-x-1/2 px-2 py-1 bg-black text-xs text-white rounded opacity-0 group-hover:opacity-100 transition">
              Instagram
            </span>
          </a>

          <a
            href="https://www.farpost.ru/user/XiaomiMi64Store"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative w-9 h-9 bg-[#232323] rounded-full flex items-center justify-center hover:bg-[#333] transition font-bold text-white"
          >
            F
            <span className="absolute bottom-12 left-1/2 -translate-x-1/2 px-2 py-1 bg-black text-xs text-white rounded opacity-0 group-hover:opacity-100 transition">
              FarPost
            </span>
          </a>
        </div>
      </div>
    </div>

    {/* Разделитель */}
    <hr className="border-gray-700 my-8" />

    {/* Копирайт */}
    <div className="text-center text-xs text-gray-400">
      © Mi64 2020–2025. Все права защищены.
    </div>
  </footer>
);

export default Footer;
